import { useSyncExternalStore } from 'react';

import { getReferralCode, subscribeReferralCode } from './referralCode';

export type PublicPartner = 'mastercard';

const PARTNER_PREFIXES: ReadonlyArray<readonly [PublicPartner, string]> = [['mastercard', 'mastercard_']];

/**
 * Maps a referral code to the public partner whose branding it unlocks.
 * The match is on the prefix only, case-insensitive and trimmed, so backend-issued
 * codes such as `mastercard_summer26` all resolve to the same partner.
 */
export const resolvePublicPartner = (code: string | null | undefined): PublicPartner | null => {
  if (!code) return null;

  const normalized = code.trim().toLowerCase();
  const match = PARTNER_PREFIXES.find(([, prefix]) => normalized.startsWith(prefix));

  return match ? match[0] : null;
};

const getSnapshot = (): PublicPartner | null => resolvePublicPartner(getReferralCode());

/** The public partner whose co-branding is active for this browser, or null for the default look. */
export const usePublicPartner = (): PublicPartner | null =>
  useSyncExternalStore(subscribeReferralCode, getSnapshot, () => null);
